import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import {
  getBracketRounds,
  isForecastView,
  selectBracketsForecast,
  selectBrackets,
} from '@selectors/matches';
import { isSnapshotView } from '@selectors/location';

// Capa a mostrar según la vista (un solo toggle Pronóstico/Resultados):
//   - snapshot (/mi-mundialito, /mundial-ideal/:userId) -> 'original' (Vista 1)
//   - subpage 'forecast'  -> 'effective' (tu pronóstico actual: original + comodín)
//   - subpage 'results'   -> 'real'      (resultados reales)
export const selectBracketViewLayerName = (state) => {
  if (isSnapshotView(state)) return 'original';
  if (isForecastView(state)) return 'effective';
  return 'real';
};

export const selectBracketViewKeyed = (state) => {
  const layer = selectBracketViewLayerName(state);
  return get(state, ['bracketView', layer]) || {};
};

// { mid: assertions } de la capa vigente. Sirve para inyectar marcas de aciertos
// de forma consistente en CUALQUIER vista (grupos y bracket), desde el server.
export const selectViewAssertionsByMid = (state) => {
  const keyed = selectBracketViewKeyed(state);
  return Object.keys(keyed).reduce((acc, mid) => {
    acc[mid] = (keyed[mid] && keyed[mid].assertions) || [];
    return acc;
  }, {});
};

// Mergea las assertions de la capa vigente sobre una lista de partidos (por mid).
export const withViewAssertions = (matches, assertionsByMid) =>
  (matches || []).map((m) => {
    if (!m || m.mid == null) return m;
    const a = assertionsByMid[m.mid] ?? assertionsByMid[String(m.mid)];
    return a !== undefined ? { ...m, assertions: a } : m;
  });

export const selectBracketViewBrackets = (state) => {
  const keyed = selectBracketViewKeyed(state);
  // Sin datos del server (p.ej. usuario no autenticado): caer al bracket real
  // calculado desde `matches`, para no romper la vista pública de resultados.
  if (isEmpty(keyed)) {
    return selectBrackets(state);
  }
  return getBracketRounds(keyed, state.config);
};

// Usa el bracket calculado por el server salvo en el editor de pronóstico.
export const usesBracketViewForDisplay = (state) =>
  isSnapshotView(state) || !isForecastView(state);

// Layout final (forward/reverse/final) para CUALQUIER vista:
//   - editor editable (subpage forecast + se puede editar: pre-cierre o comodín)
//     -> pipeline editable (forecastMatches), para poder cargar/cambiar picks.
//   - resto -> bracket calculado por el server (capa real/effective/original).
export const selectDisplayBrackets = (state) => {
  const inForecastPage = isForecastView(state) && !isSnapshotView(state);
  return inForecastPage
    ? selectBracketsForecast(state)
    : selectBracketViewBrackets(state);
};
